import moment from "moment";
import { getDefaultPhoneCountry, normalizePhoneNumber } from "../../utils/phone";

const compact = (object) =>
  Object.keys(object).reduce((result, key) => {
    const value = object[key];
    if (value !== undefined && value !== null && value !== "") {
      result[key] = value;
    }
    return result;
  }, {});

const normalizeRelation = (relation) => {
  const next = { ...(relation || {}) };
  next.name = [next.firstName, next.lastName].filter(Boolean).join(" ");
  if (next.dob) next.dob = moment(next.dob).format("DD/MM/YYYY");
  return compact(next);
};

export const buildMemberCreatePayload = (values, context = {}) => {
  const source = { ...(values || {}) };
  delete source.id;
  delete source.packageDetails;

  const defaultCountry = getDefaultPhoneCountry(
    context.country || source.country
  );
  if (source.phone) {
    const phone = normalizePhoneNumber(source.phone, defaultCountry);
    source.phone = phone.value;
    source.country = phone.country || defaultCountry;
  } else {
    source.country = defaultCountry;
  }

  source.name = [source.firstName, source.lastName].filter(Boolean).join(" ");
  source.relations = (source.relations || []).map(normalizeRelation);
  if (source.dob) source.dob = moment(source.dob).format("DD/MM/YYYY");

  if (source.RFIDCardIdField) {
    source.cardMembershipId = String(source.RFIDCardIdField).trim();
    source.requireCard = true;
  }
  if (context.requireCard) source.requireCard = true;
  if (source.phone && !source.verifyBy) source.verifyBy = "phone";
  if (!source.phone && source.email && !source.verifyBy) {
    source.verifyBy = "email";
  }

  return compact(source);
};

export const validateMemberCreatePayload = (payload) => {
  const errors = {};
  if (!payload.firstName) errors.firstName = "First name is required";
  if (!payload.gender) errors.gender = "Gender is required";
  if (!payload.email && !payload.phone) {
    errors.contact = "Email or phone is required";
  }
  if (payload.phone) {
    const normalized = normalizePhoneNumber(payload.phone, payload.country);
    if (!normalized.valid) errors.phone = "Phone number is invalid";
  }
  if (payload.requireCard && !payload.cardMembershipId) {
    errors.RFIDCardIdField = "RFID card is required";
  }
  return errors;
};
